const FocusableEventType = {
    BLUR: 'blur',
    DOWN: 'down',
    FOCUS: 'focus',
    FOCUS_CHANGE: 'focuschange',
    FOCUS_WILL_CHANGE: 'focuswillchange',
    LEFT: 'left',
    RIGHT: 'right',
    SELECT: 'select',
    UP: 'up',
} as const;

type TFocusableEventType = typeof FocusableEventType[keyof typeof FocusableEventType];

export type {TFocusableEventType};
export {FocusableEventType as default};
